import * as React from 'react'

import { Box, RadioButton, Text } from '@factorialco/deprecated-design-system'
import { AttendanceEnumsBreakViolationsHandlingEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  breakViolationsHandling: AttendanceEnumsBreakViolationsHandlingEnum
  onBreakViolationChange: (value: AttendanceEnumsBreakViolationsHandlingEnum) => void
}

const BreakViolationHandler: React.FC<Props> = ({
  breakViolationsHandling,
  onBreakViolationChange,
}) => {
  return (
    <Box gap="s8">
      <Text.Normal weight="medium" size="200" color="grey1000">
        {i18n.t('time_tracking.settings.breaks.instance.break_violations_handling.description')}
      </Text.Normal>
      <Box gap="s8">
        <RadioButton
          name={i18n.t('time_tracking.settings.breaks.instance.break_violations_handling.autofix')}
          value="autofix"
          checked={breakViolationsHandling === 'autofix'}
          onChange={() => onBreakViolationChange('autofix')}
          label={i18n.t('time_tracking.settings.breaks.instance.break_violations_handling.autofix')}
        />
        <RadioButton
          name={i18n.t(
            'time_tracking.settings.breaks.instance.break_violations_handling.no_action'
          )}
          value="no_action"
          checked={breakViolationsHandling === 'no_action'}
          onChange={() => onBreakViolationChange('no_action')}
          label={i18n.t(
            'time_tracking.settings.breaks.instance.break_violations_handling.no_action'
          )}
        />
      </Box>
    </Box>
  )
}

export default BreakViolationHandler
